import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { memo, useEffect } from 'react';

const AutoFocusPlugin = memo(({ autoFocus }) => {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    if (autoFocus) {
      editor.focus();
    }
  }, [editor, autoFocus]);
  return null;
});

AutoFocusPlugin.displayName = 'AutoFocusPlugin';

export default AutoFocusPlugin;
